import { useAuth } from "./use-auth";

export function useActiveOrg() {
  const { selectedMembership } = useAuth();

  return {
    org: selectedMembership,
  };
}
